module.exports = __webpack_public_path__ + "static/housing.901f80b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/housing.svg
// module id = 488
// module chunks = 35783957827783